import { jsx as s } from "react/jsx-runtime";
import { Heading as i } from "../../Heading/Heading.js";
const r = {
  md: "xs",
  lg: "sm",
  xl: "md"
}, e = ({
  size: m = "md",
  ...o
}) => /* @__PURE__ */ s(i, { size: r[m], ...o });
export {
  e as CardTitle
};
